export enum TranslationStatusValue {
  Unknown = 0,
  NotTranslated = 1,
  PartiallyTranslated = 2,
  Translated = 3,
}
